import React from 'react';
import { BUTTON_TYPES, components as Core, useTranslation } from '../../../../core';
import { common, css, colors, spacing, StyleSheet } from '../../../../../styles';

/**
 * Renders integration save actions.
 *
 * @param {object} props
 * @param {boolean} props.hasUpdated
 * @param {boolean} props.isSaving
 * @param {Function|null} props.onClose
 * @param {Function|null} props.onSave
 */
export const IntegrationDetailsFooter = ({
    hasUpdated = false,
    isSaving = false,
    onClose = null,
    onSave = null
}) => {
    const { t } = useTranslation();

    return (
        <div className={css(common.flexRowEnd, styles.footer)}>
            <Core.Button
                label={t('cancel')}
                onPress={onClose}
                type={BUTTON_TYPES.blueOutline}
            />
            <Core.Button
                label={t('save')}
                onPress={onSave}
                isLoading={isSaving}
                isDisabled={isSaving || !hasUpdated}
                className={styles.saveButton}
            />
        </div>
    );
};

const styles = StyleSheet.create({
    footer: {
        marginTop: spacing.s4,
        paddingTop: spacing.s4,
        borderTop: `1px solid ${colors.greyLight}`,
        gap: spacing.s1
    },
    saveButton: {
        '&.ant-btn-primary[disabled]': {
            color: `${colors.blackOpacity} !important`,
            backgroundColor: `${colors.background} !important`,
            borderColor: `${colors.border} !important`,
            boxShadow: 'none !important'
        }
    }
});
